// --- Modules
import Node, { payload } from './Node';

class Data extends Node {
  constructor(opts) {
    super(opts);

    Object.defineProperty(this, 'nodeClass', {
      enumerable: false,
      configurable: false,
      writable: false,
      value: 'Data'
    });
  }
};

export default {
  create: (opts) => {
    let item = new Data(opts);
    payload.nodes.push(item);
    return payload.nodes[payload.nodes.length - 1];
  }
};
